import { toast } from "react-toastify";
import { EmergencyContactRow, EmergencyContactSearchFields, IEmergencyContactQueryParams } from "models/emergency-contact";

export const getEmergencyContacts = async (query?: IEmergencyContactQueryParams): Promise<EmergencyContactRow[] | null> => {
    try {
        const params = new URLSearchParams();
        Object.entries(query ?? {}).forEach(([key, value]) => {
            if (value === undefined || value === null || String(value).trim() === '') return;
            params.append(key, String(value).trim());
        });
        const queryString = params.toString();

        const url = `${process.env.REACT_APP_API_URL}/emergency-contact${queryString ? `?${queryString}` : ''}`;

        const res = await fetch(url, {
            credentials: 'include',
            method: 'GET',
        });

        if (!res.ok) {
            const errBody = await res.json();
            throw new Error(errBody.message);
        }

        const data = await res.json();
        return data.data as EmergencyContactRow[]
    } catch (err: any) {
        toast.error(err.message ?? "Error getting Emergency Contacts");
        return null;
    }
}

export const getEmergencyContactSearchFields = async (): Promise<EmergencyContactSearchFields | null> => {
    try {
        const url = `${process.env.REACT_APP_API_URL}/emergency-contact/search-fields`;

        const res = await fetch(url, {
            credentials: 'include',
            method: 'GET',
        });

        if (!res.ok) {
            const errBody = await res.json();
            throw new Error(errBody.message);
        }

        const data = await res.json();
        return data.data as EmergencyContactSearchFields
    } catch (err: any) {
        toast.error(err.message ?? "Error getting Emergency Contact search fields");
        return null;
    }
}
